import { useLocation, Link } from "react-router-dom";

import "./NavBar.scss";
import ThemeToggle from "../../ThemeToggle";

const NavBar = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <>
      <div className="navbar__container">
        <div className="navbar__row">
          <Link
            to="/"
            className={`navbar__links ${isActive("/") ? "active" : ""}`}
          >
            Work
          </Link>

          <Link
            to="/about-me"
            className={`navbar__links ${isActive("/about-me") ? "active" : ""}`}
          >
            About
          </Link>

          <Link
            to="/contact-me"
            className={`navbar__links ${
              isActive("/contact-me") ? "active" : ""
            }`}
          >
            Contact
          </Link>
          <ThemeToggle />
        </div>
      </div>
    </>
  );
};

export default NavBar;
